// /utils/globalNetworkEvents.js

export function initGlobalNetworkLogs() {
  const ts = () => new Date().toISOString();

  //console.log(`[GLOBAL][${ts()}] initGlobalNetworkLogs() loaded.`);

  // Network online
  window.addEventListener("online", () => {
    // console.log(`[GLOBAL][${ts()}] navigator → ONLINE`);
  });

  // Network offline
  window.addEventListener("offline", () => {
    // console.log(`[GLOBAL][${ts()}] navigator → OFFLINE`);
  });

  // Page visibility change (tab change, resume, freeze)
  document.addEventListener("visibilitychange", () => {
    // console.log(`[GLOBAL][${ts()}] visibilitychange → document.visibilityState = "${document.visibilityState}"`);
  });

  // Chrome freeze/resume lifecycle API (not supported everywhere)
  if ("onresume" in window) {
    window.addEventListener("resume", () => {
      // console.log(`[GLOBAL][${ts()}] PAGE RESUMED (Chrome freeze API)`);
    });
  } else {
    // console.log(`[GLOBAL][${ts()}] window.onresume not supported on this browser`);
  }

  // Initial state
  // console.log(`[GLOBAL][${ts()}] navigator.onLine = ${navigator.onLine}`);
}
